const STATUS = {
  none: 'none',
  waiting: 'waiting',
  retrying: 'retrying',
  success: 'success',
  error: 'error',
}
export default STATUS
